<div class="image-container">
    <h3>{{data.titulo}}</h3>
    <img [src]="data.url" [alt]="data.titulo" class="viewer-img">
    <button class="close-btn" (click)="close()">Cerrar</button>
</div>
